import {Directive, HostBinding, HostListener, Input} from '@angular/core';
import {Router} from '@angular/router';
import { NavigationService } from 'src/app/services/navigation.service';

@Directive({
  selector: '[backButton]',
  standalone: false
})
export class BackButtonDirective {
  @HostBinding('class.material-icons-rounded') backButtonClass = true;
  @Input() backPath = '';

  constructor(
    private router: Router,
    private navigationService: NavigationService
  ) { }

  @HostListener('click')
  goToBack(): void {
    const action = this.navigationService.backButtonAction;

    if(action) return action();
    else if (this.backPath) {
      this.router.navigate([this.backPath]);
      return;
    }
    window.history.back();
  }

}
